package com.trevorwiebe.timesheet.admin.rate.presentation

import com.trevorwiebe.timesheet.core.presentation.DisposableViewModel
import androidx.lifecycle.viewModelScope
import com.trevorwiebe.timesheet.admin.rate.domain.RateRepository
import com.trevorwiebe.timesheet.core.domain.model.Rate
import kotlinx.coroutines.flow.MutableStateFlow
import kotlinx.coroutines.flow.asStateFlow
import kotlinx.coroutines.flow.update
import kotlinx.coroutines.launch

class RateViewModel(
    private val rateRepository: RateRepository
) : DisposableViewModel() {

    private val _state = MutableStateFlow(RateState())
    val state = _state.asStateFlow()

    init {
        loadRates()
    }

    fun onEvent(event: RateEvent) {
        when (event) {
            is RateEvent.OnAddRateClick -> {
                _state.update { it.copy(showAddEditDialog = true, editingRate = null) }
            }
            is RateEvent.OnEditRateClick -> {
                _state.update { it.copy(showAddEditDialog = true, editingRate = event.rate) }
            }
            is RateEvent.OnDismissDialog -> {
                _state.update { it.copy(showAddEditDialog = false, editingRate = null) }
            }
            is RateEvent.OnSaveRate -> {
                saveRate(event)
            }
            is RateEvent.OnErrorShown -> {
                _state.update { it.copy(error = null) }
            }
        }
    }

    private fun loadRates() {
        viewModelScope.launch {
            _state.update { it.copy(isLoading = true) }
            rateRepository.getRates().collect { result ->
                if (result.error != null) {
                    _state.update { it.copy(isLoading = false, error = result.error) }
                } else {
                    @Suppress("UNCHECKED_CAST")
                    val rates = result.data as List<Rate>
                    _state.update { it.copy(isLoading = false, rates = rates, error = null) }
                }
            }
        }
    }

    private fun saveRate(event: RateEvent.OnSaveRate) {
        val description = event.description.trim()
        val rateCode = event.rateCode.trim()
        val overtimeRateCode = event.overtimeRateCode.trim()
        if (description.isBlank() || rateCode.isBlank()) return
        viewModelScope.launch {
            val editing = _state.value.editingRate
            val result = if (editing == null) {
                rateRepository.addRate(
                    Rate(
                        id = "",
                        description = description,
                        userFacing = true,
                        defaultRate = event.defaultRate,
                        rateCode = rateCode,
                        overtimeRateCode = overtimeRateCode
                    )
                )
            } else {
                rateRepository.updateRate(
                    editing.copy(
                        description = description,
                        defaultRate = event.defaultRate,
                        rateCode = rateCode,
                        overtimeRateCode = overtimeRateCode
                    )
                )
            }
            if (result.error != null) {
                _state.update { it.copy(error = result.error) }
            } else {
                _state.update { it.copy(showAddEditDialog = false, editingRate = null) }
            }
        }
    }
}
